import React from "react";
import { Grid } from "Components/Base/Layout";
import { Box } from "Components/Base/Layout/Box";
import ButtonUnderlined from "Components/Fragment/ButtonUnderlined";
import DateFilters from "./DateFilters";
import SessionFilters from "./SessionFilters";
import CategoryFilters from "./CategoryFilters";
import {
  STYLE_FILTER_MOBILE_DETAILS,
  STYLE_FILTER_MOBILE_ITEM,
} from "../../styles";

const FilterMobileDetails = ({
  languageContext,
  hasActiveFilters,
  resetFilters,
  startDate,
  endDate,
  handleDateChange,
  uniqueRegions,
  uniqueCities,
  sessionRegion,
  sessionCity,
  handleSessionChange,
  otherCategories,
  categoriesValue,
  handleChange,
}) => {
  return (
    <Box sx={STYLE_FILTER_MOBILE_DETAILS}>
      {hasActiveFilters && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          sx={{ mb: 1, px: 1 }}
        >
          <ButtonUnderlined
            label={languageContext("clearFilters")}
            onClick={resetFilters}
            size="small"
          />
        </Box>
      )}

      <Grid container spacing={1}>
        <DateFilters
          languageContext={languageContext}
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateChange}
          isMobile={true}
        />
        <SessionFilters
          languageContext={languageContext}
          uniqueRegions={uniqueRegions}
          uniqueCities={uniqueCities}
          sessionRegion={sessionRegion}
          sessionCity={sessionCity}
          onChange={handleSessionChange}
          isMobile={true}
        />
        <CategoryFilters
          languageContext={languageContext}
          categories={otherCategories?.categories}
          categoriesValue={categoriesValue}
          onChange={handleChange}
          isMobile={true}
        />
      </Grid>
    </Box>
  );
};

export default FilterMobileDetails;
